import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blanket',
  templateUrl: './blanket.component.html',
  styleUrls: ['./blanket.component.css']
})
export class BlanketComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
